import { Button } from '@/components/ui/button'
import { DateInput } from '@/components/ui/DateInput'
import { Field, FieldLabel } from '@/components/ui/field'

/** The coverage start date for one provider, saved on its own. */
export function StartDateField({
  id,
  date,
  onChange,
  onSave,
}: {
  id: string
  date: Date | undefined
  onChange: (date: Date | undefined) => void
  onSave: () => void
}) {
  return (
    <div className="mt-3 flex items-end gap-3">
      <Field className="max-w-60">
        <FieldLabel htmlFor={id} className="sr-only">
          Coverage start date
        </FieldLabel>
        <DateInput value={date} onChange={onChange} inputProps={{ id }} />
      </Field>
      <Button disabled={!date} onClick={onSave}>
        Save
      </Button>
    </div>
  )
}
